import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const OfflineBanner = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true), down = () => setOnline(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  if (online || localStorage.getItem("xpattern.offline") === "1") return null; // Offline-mode accounts get the dedicated banner instead
  return (
    <div className="flex items-center justify-center gap-2 bg-[#f5a524] px-3 py-1 text-[12px] font-medium text-[#1a1200]" data-testid="offline-banner">
      <WifiOff className="h-3.5 w-3.5" /> You're offline — the canvas keeps working; cutting and saving resume when the connection is back.
    </div>
  );
};
